/* Predictive search — debounced, abortable, keyboard-navigable. */
(function () {
  'use strict';
  const TB = window.Miniflex || {};

  class Search extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = document.querySelector('[data-search-results]');
      if (!this.input || !this.results) return;

      this.seed = this.results.innerHTML;
      this.input.addEventListener('input', this.debounce(() => this.search(), 220));
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
      this.results.addEventListener('keydown', (e) => this.onKeydown(e));
    }

    debounce(fn, wait) {
      let t;
      return function () {
        window.clearTimeout(t);
        t = window.setTimeout(fn, wait);
      };
    }

    search() {
      const terms = this.input.value.trim();
      if (terms.length < 2) {
        this.results.innerHTML = this.seed;
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const url =
        TB.routes.predictiveSearch +
        '?q=' +
        encodeURIComponent(terms) +
        '&resources[type]=product,collection,page,article&resources[limit]=5&section_id=predictive-search';

      fetch(url, { signal: this.controller.signal })
        .then((res) => res.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('.shopify-section');
          this.results.innerHTML = inner ? inner.innerHTML : text;
          this.input.setAttribute('aria-expanded', 'true');
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          this.results.innerHTML = '<p class="t-small">' + (TB.strings ? TB.strings.error : 'Search failed') + '</p>';
        });
    }

    onKeydown(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = Array.from(this.results.querySelectorAll('a'));
      if (!links.length) return;
      event.preventDefault();
      const current = links.indexOf(document.activeElement);
      const next =
        event.key === 'ArrowDown'
          ? Math.min(links.length - 1, current + 1)
          : Math.max(0, current - 1);
      if (current === -1 && event.key === 'ArrowDown') {
        links[0].focus();
      } else {
        links[next].focus();
      }
    }
  }

  if (!customElements.get('tb-search')) customElements.define('tb-search', Search);
})();
